/**
 * Guide · Location review — the /reports/storage "Slotting review". SKUs whose
 * velocity and depth call for a dedicated lane or automation, ranked fastest
 * first. A recommendation to check against the WMS, not a claim of where a SKU
 * sits today — no pick-location feed exists in this data.
 */

import { GuidePage } from "@/features/guide/guide-page";

export function GuideLocationPage() {
  return (
    <GuidePage
      eyebrow="Location review"
      title="What belongs in a lane or in automation."
      intro="Location review ranks the SKUs whose velocity and holding depth make the case for a dedicated A-frame lane or an automation pick, fastest first. It is a recommendation, not a mismatch list: no pick-location feed exists in this data, so nothing here claims where a SKU sits today. You check each row against the WMS, accept or remove it, and export the accepted set for the slotting team to action."
      liveBullets={[
        {
          text: "Every candidate SKU with its velocity, held quantity, estimated depth, recommended home, and the reasoning",
        },
        { text: "Ranked so the rows that matter most sit at the top — no scroll-limited sample" },
        { text: "Accept or remove each row; the accepted set is what you hand off" },
        {
          text: "Export all rows to CSV — the full list, each with its decision, for the WMS team to check",
        },
      ]}
      walkthrough={[
        {
          step: "Read the recommendation",
          body: "The narrative states what the review found and why it's a recommendation, not a record of current slots.",
        },
        {
          step: "Accept or remove",
          body: "Work down the ranked rows, checking each against the WMS, and strike off anything that doesn't hold up.",
        },
        {
          step: "Export the list",
          body: "Download every row as CSV — with its Accepted / Removed decision — for the slotting team to action.",
        },
      ]}
      cta={{ to: "/reports/storage", label: "Open Location review" }}
    />
  );
}
